<template>
  <Main :metadata="metadata" :documents-from-request="documentsFromRequest" />
</template>

<script>
import { state, mutations } from '@/components/FileUpload/Observables/fileUpload'
import Main from '@/components/FileUpload/Main'

export default {
  props: {
    metadata: {
      type: Object,
      default: {}
    },
    documentsFromRequest: {
      type: Array,
      default: []
    }
  },
  provide: { state, mutations },
  components: {
    Main
  },
  computed: {
    documents() {
      return state.documentsToUpload
    }
  },
  watch: {
    documents: function(newVal, oldVal) {
      this.$emit('documents', newVal)
    }
  }
}
</script>